(function () {
	'use strict';
	if (window.__condePosthogClicks) return;
	window.__condePosthogClicks = true;

	function readForm(form) {
		if (!form) return {};
		var variantInput = form.querySelector('input[name="id"]');
		var quantityInput = form.querySelector('input[name="quantity"]');
		return {
			variant_id: variantInput ? variantInput.value : null,
			quantity: quantityInput ? Number(quantityInput.value) || 1 : 1,
			form_action: form.getAttribute('action') || null
		};
	}

	function readProductMeta(scope, variantId) {
		var nodes = (scope || document).querySelectorAll('[data-js-product-json], [data-product-json], script[type="application/json"][data-product]');
		for (var i = 0; i < nodes.length; i++) {
			try {
				var data = JSON.parse(nodes[i].textContent);
				var matches = String(data.selected_or_first_available_variant && data.selected_or_first_available_variant.id) === variantId || (data.variants || []).some(function (v) { return String(v.id) === variantId; });
				if (!matches) continue;
				return { product_id: data.id || data.product_id || null, product_title: data.title || null, product_handle: data.handle || null, product_type: data.type || data.product_type || null, vendor: data.vendor || null };
			} catch (_) { /* Unknown metadata stays unknown. */ }
		}
		return {};
	}

	function onClick(event) {
		if (!window.posthog || typeof window.posthog.capture !== 'function') return;
		var checkout = event.target.closest && event.target.closest('button[name="checkout"], input[name="checkout"], a[href]');
		if (checkout && checkout.tagName === 'A') {
			try {
				var destination = new URL(checkout.getAttribute('href'), window.location.href);
				if (destination.origin !== window.location.origin || !/^\/checkout\/?$/.test(destination.pathname)) checkout = null;
			} catch (_) { checkout = null; }
		}
		if (checkout) {
			if (checkout.disabled || checkout.getAttribute('aria-disabled') === 'true') return;
			if (!window.CondeTelemetry || !window.CondeTelemetry.allowed()) return;
			try {
				// Storefront intent remains observable when the destination cannot run pixels.
				// This is not Shopify's checkout_started or a purchase confirmation.
				window.posthog.capture('checkout_clicked', {
					source: 'theme_click',
					path: window.location.pathname,
					checkout_entry: checkout.tagName === 'A' ? 'checkout_link' : 'checkout_button'
				});
			} catch (_) { /* Analytics must not interrupt checkout. */ }
			return;
		}
		var btn = event.target.closest && event.target.closest('.add-to-cart');
		if (!btn) return;
		var form = btn.closest('form[action*="/cart/add"]') || btn.closest('form');
		var fields = readForm(form);
		var scope = btn.closest('[data-product-json-wrapper], .product, .product-form') || document;
		var productMeta = readProductMeta(scope, fields.variant_id);
		if (!productMeta.product_id && scope !== document) productMeta = readProductMeta(document, fields.variant_id);
		var props = Object.assign(
			{ source: 'theme_click', path: window.location.pathname },
			productMeta,
			fields
		);

		window.posthog.capture('add_to_cart_clicked', props);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			document.addEventListener('click', onClick, true);
		});
	} else {
		document.addEventListener('click', onClick, true);
	}
})();
